
export const FigureTypeGroup = 'draw2d.shape.composite.Group';

export function isGroupFigure(canvasFigure) {
    return canvasFigure.NAME === FigureTypeGroup;
}
